import * as Sentry from '@sentry/react'
import AppRoutes from './Routes'
import { Toaster } from 'sonner'

const FallbackComponent = () => (
  <div style={{ padding: '20px', textAlign: 'center' }}>
    <h1>發生錯誤</h1>
    <p>頁面載入時發生問題，請重新整理或聯繫管理員。</p>
    <button onClick={() => window.location.reload()}>重新整理</button>
  </div>
)

const App = () => {
  return (
    <Sentry.ErrorBoundary fallback={<FallbackComponent />}>
      <AppRoutes />
      <Toaster richColors closeButton position="top-right" />
    </Sentry.ErrorBoundary>
  )
}

export default App
